/**
 * Runtime configuration.
 *
 * Everything is same-origin by default: `vite.config.ts` proxies `/v1` to the
 * Rust API in dev, and in production the API is expected to sit behind the same
 * host. That is no longer only a convenience — the session lives in a cookie
 * scoped to `/v1`, and a cookie is what lets a websocket handshake and
 * MapLibre's own requests authenticate themselves, neither of which can set a
 * header. Point `VITE_API_BASE_URL` elsewhere only if you have arranged for the
 * cookie to reach it.
 */
const rawBase = (import.meta.env.VITE_API_BASE_URL ?? '').trim().replace(/\/+$/, '')

export const API_BASE = rawBase

/** Optional style id; the API's default style is used when unset. */
export const STYLE_ID = (import.meta.env.VITE_PROXIMIIO_STYLE_ID ?? '').trim()

/** Optional place filter for the floor list. */
export const PLACE_ID = (import.meta.env.VITE_PROXIMIIO_PLACE_ID ?? '').trim()

/**
 * Capture guidance (BLE survey / 3D scan grids) is hidden for now, 2026-09-23:
 * the tool is a walk-around aid for surveyors, and the operators using LiveView
 * today are here for live positions and journeys. The code stays; flipping this
 * brings the sidebar section, the guidance card and the grid layers back. While
 * hidden, a capture mode left in `localStorage` from before is treated as off,
 * so a grid cannot keep drawing itself with no way to switch it off.
 */
export const CAPTURE_ENABLED = false

export function apiUrl(path: string): string {
  const suffix = path.startsWith('/') ? path : `/${path}`
  return `${API_BASE}${suffix}`
}

export function websocketUrl(): string {
  const base = API_BASE || window.location.origin
  const url = new URL(`${base}/v1/ws`, window.location.origin)
  url.protocol = url.protocol === 'https:' ? 'wss:' : 'ws:'
  return url.toString()
}
